<template>
  <div class="over_layout" v-if="renderTemplate">
    <section class="edit_cv">
      <div class="wrapper">
        <div class="edit_block">
          <div class="cv_chang_area show">
            <div class="cv_craft" id="cv_craft" v-if="load_page" ref="cvCraft">
              <div class="wathermaker"></div>
              <div :class='this.$store.state.cv.cvTheme.class_name' id='cv_pro_2'>
                <div class='bg_area'>
                  <div class='cv_them_top_cv_block'>
                    <div class='cv_them_left_img_name_block'>
                      <div class='cv_them_img_block'>
                        <img :src="$store.state.cv.photo || '/vue/images/user_img.jpg'">
                      </div>
                    </div>
                    <div class='cv_them_right_block'>
                      <div class='cv_them_block'>
                        <div class='cv_them_name'>
                          {{ $store.state.cv.name }} {{ $store.state.cv.surname }}
                        </div>
                        <div class='cv_them_profession'>
                          {{ $store.getters.cvProfessions }}
                        </div>
                      </div>
                      <div class='cv_them_block cv_them_career'>
                        <div class='cv_them_name_block'>
                          {{ $store.getters.cv_t('career_objective') }}
                        </div>
                        <p
                          v-html="$store.getters.career_objective()"
                        ></p>
                      </div>
                    </div>
                  </div>
                  <div class='cv_them_all_blocks'>
                    <div class='cv_them_left_block'>
                      <div class='cv_them_block cv_them_block_conditions'>
                        <div class='cv_them_name_block'>
                          {{ $store.getters.cv_t('conditions') }}
                        </div>
                        <ul>
                          <li class='cv_them_pro_Conditions1_1'>
                            {{ correctDate($store.state.cv.date) }}
                          </li>
                          <li class='cv_them_pro_Conditions1_2'>
                            {{ $store.state.cv.jobStack.title }}
                          </li>
                          <li class='cv_them_pro_Conditions1_3'>
                            <template v-if="$store.state.cv.jobStack.sallery">
                              {{ $store.getters.cv_t('from')}}
                              <span>
                                               {{ XFormatPrice($store.state.cv.jobStack.sallery) }}
                                               <span
                                                 v-if="$store.state.cv.jobStackPlus"
                                               >+</span>
                                             </span>
                              {{ $store.state.cv.jobStackCurrency.symbol}}
                            </template>
                            <template v-else>
                              <span>{{ $store.getters.cv_t('contractual')}}</span>
                            </template>
                          </li>
                        </ul>
                      </div>
                      <div class='cv_them_block cv_them_block_contact'>
                        <div class='cv_them_name_block'>{{ $store.getters.cv_t('cv_contact') }}</div>
                        <ul>
                          <li class='cv_them_pro_tel' v-if="$store.state.cv.phone">
                            <a
                              :href="`tel:${$store.state.cv.phone}`">
                              {{$store.state.cv.phone}}</a>
                          </li>
                          <li class='cv_them_pro_mail'>
                            <a :href="`mailto:${$store.state.cv.email}`">
                              {{$store.state.cv.email}}</a>
                          </li>
                          <li class='cv_them_pro_address' v-if="$store.state.cv.address.address && $store.state.cv.address.address !== 'ZERO_RESULTS'">
                            {{ $store.state.cv.address.address }}
                          </li>
                          <template v-if="$store.state.cv.hasSocial">
                            <li class='cv_them_pro_soc'
                                v-for="(icon, index) in $store.state.cv.cvSocials"
                                :key="'icon'+index"
                                :class="icon.class_name">
                              <a :href="icon.url" target="_blank">
                                {{ convertSocial( icon.url, icon.icon ) }}
                              </a>
                            </li>
                          </template>
                        </ul>
                      </div>
                      <div class='cv_them_block cv_them_skills'>
                        <div class='cv_them_name_block'>
                          {{ $store.getters.cv_t('skills') }}
                        </div>
                        <div class='cv_them_list'>
                          <ul>
                            <li v-for="skill in $store.state.cv.cvSkills" :class="lineBr(skill)"
                                :key="'skill'+skill.id">
                              <div class='cv_them_skill_percent'>
                                <div class='cv_them_skill'>{{ skill.title }}</div>
                                <div class='cv_them_percent'>{{ skill.percent }}%</div>
                              </div>
                              <div class='cv_them_bg_lines'>
                                <div class='cv_them_bg_line_active'
                                     v-bind:style="{width: skill.percent + '%' }"></div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class='cv_them_block cv_them_lang'>
                        <div class='cv_them_name_block'>
                          {{$store.getters.cv_t("languages")}}
                        </div>
                        <div class='cv_them_list'>
                          <ul>
                            <li v-for="lang in $store.state.cv.cvLanguages" :class="lineBr(lang)" :key="'lang'+lang.id">
                              <vue-circle :ref="'lang_' + lang.id"
                                          :progress="lang.percent"
                                          :size="45"
                                          :fill="fill"
                                          empty-fill="rgba(0, 0, 0, .1)"
                                          :animation-start-value="0.0"
                                          :start-angle="11"
                                          insert-mode="append"
                                          :thickness="5"
                                          :show-percent="true">
                              </vue-circle>
                              <div class='cv_them_lang_name'>{{ lang.name }}</div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class='cv_them_block cv_them_block_hobby'
                           v-if="$store.state.cv.hasHobby && $store.state.cv.hobbies.length > 0">
                        <div class='cv_them_name_block'>
                          {{$store.getters.cv_t("hobby")}}
                        </div>
                        <ul>
                          <li v-for="(hobby, index) in $store.state.cv.hobbies" :class="lineBr(hobby)"
                              :key="'hobby'+index">
                            {{ hobby.title }}
                          </li>
                        </ul>
                      </div>
                      <div class='cv_them_block cv_them_block_info'
                           v-if="$store.state.cv.cvCitizens && $store.state.cv.cvCitizens.length > 0">
                        <div class='cv_them_name_block'>{{ $store.getters.cv_t('citizen')}}</div>
                        <ul>
                          <li v-for="citizen in $store.state.cv.cvCitizens"
                              :key="'citizen'+citizen.id" :class="lineBr(citizen)">
                            {{citizen.title}}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class='cv_them_right_block'>
                      <div class='cv_them_block cv_them_block_education' v-if="$store.state.cv.educations.length">
                        <!-- start educations -->
                        <template v-for="(page,index) in pages">
                          <p v-for="(p_count,p_index) in page.count"
                             class='new-line-br'
                             v-if="page.type === 'educations' && page.type_id === -1"
                             :key="'page'+p_count.id+key+p_index"
                          ></p>
                        </template>
                        <div class='cv_them_name_block'>
                          {{ $store.getters.cv_t('education') }}
                        </div>
                        <template v-for="(education, index) in $store.state.cv.educations">
                          <template v-for="(page) in pages">
                            <p v-for="(p_count,p_index) in page.count"
                               class='new-line-br'
                               v-if="page.type === 'educations' && page.type_id === index"
                               :key="'experience'+page.id+key+p_index"
                            ></p>
                          </template>
                          <div class="cv_them_block_item" :key="'ex'+index">
                            <div class='cv_them_block_dates_info'>
                              <div class='cv_them_dates'>
                                {{ correctDate(education.start, {month: true}) }} -
                                {{ correctDate(education.end, {month: true}) ||
                                $store.getters.cv_t("present") }}
                              </div>
                              <span>
                                          {{ education.location.address }}
                                       </span>
                              <span>{{ education.university }}</span>
                            </div>
                            <div class='cv_them_specialty'>
                              {{ education.faculty }},
                              {{ education.specialization.title }},
                              {{ education.degree.title }}
                            </div>
                            <p
                              v-html="education.description ? education.description.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''"
                            ></p>
                          </div>
                        </template>
                        <!-- end educations -->
                      </div>
                      <div class='cv_them_block cv_them_block_work' v-if="$store.state.cv.hasExperience && $store.state.cv.experiences.length">
                        <!-- start experiences-->
                        <template v-for="(page,index) in pages">
                          <p v-for="(p_count,p_index) in page.count"
                             class='new-line-br'
                             v-if="page.type === 'experiences' && page.type_id === -1"
                             :key="'page'+p_count.id+key+p_index"
                          ></p>
                        </template>
                        <div class='cv_them_name_block'>
                          {{ $store.getters.cv_t('work_experience') }}
                        </div>
                        <template v-for="(experience, index) in $store.state.cv.experiences">
                          <template v-for="(page) in pages">
                            <p v-for="(p_count,p_index) in page.count"
                               class='new-line-br'
                               v-if="page.type === 'experiences' && page.type_id === index"
                               :key="'experience'+page.id+key+p_index"
                            ></p>
                          </template>
                          <div class='cv_them_block_item'

                               :key="'exp' + index">
                            <div class='cv_them_block_dates_info'>
                              <div class='cv_them_dates'>
                                {{ correctDate(experience.start, {month: true}) }} -
                                {{ correctDate(experience.end, {month: true}) ||
                                $store.getters.cv_t("present") }}
                              </div>
                              <span>{{ experience.location.address }}</span>
                              <span>{{ experience.company }}</span>
                            </div>

                            <div class='cv_them_specialty'>
                              {{ experience.specialization.title }}
                            </div>
                            <p
                              v-html="experience.description ? experience.description.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''"></p>
                          </div>
                        </template>
                      </div>
                      <div class="logo">
                        <a href="https://cvweb.ru" target="_blank">
                          <img src="/vue/images/cv_logo_cv.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="button_download_icon">
            <div @click="$store.commit('cvDownload', {show: true, cv: Number(cv) })">
              <img src="/vue/images/icon_download.png">
            </div>
            <router-link
              class="edite_btn"
              :to="{
                        name: 'cv-edit-' + $store.state.typeCv,
                        params: {
                          lang: $store.getters.locale,
                          cv: cv
                        }
                      }"
            ></router-link>
            <div @click="destroy(cv)">
              <img src="/vue/images/delete.png">
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import CvFunctions from "../../../cv-functions.js";
  import ResizeStyle from "../../../../../../mixins/cv-resize.js";
  import Seo from "../../../../../../mixins/seo";
  import VueCircle from 'vue2-circle-progress';


  export default {
    mixins: [CvFunctions, Seo, ResizeStyle],
    data() {
      return {
        cv: this.$route.params.cv,
        fill: {gradient: [this.getCircleColor('p-2')]},
        load_page: false
      };
    },
    components: {
      VueCircle
    },
    mounted() {
      this.show(this.cv);
    },
    methods: {
      show(cv) {
        this.$http({
          method: "get",
          url: `/api/cv/${cv}`
        }).then(res => {
          if (res.data.cv) {
            this.cv = res.data.cv.id;
            this.setCvState(res.data.cv);
            setTimeout(() => {
              this.checkLocale(this.$store.getters.cv_locale);
              this.load_page = true;
            }, 1);
            this.renderTemplate = true;
          }
        });
      },
      destroy(cv) {
        if (confirm('Are you sure ?')) {
          this.$http({
            method: "delete",
            url: `/api/cv/${cv}`
          }).then(res => {
            if (res.data.success) {
              this.$router.push({
                name: "profile",
                params: {lang: this.$store.getters.locale}
              });
              this.$store.commit("newMessage", {
                show: true,
                type: "success",
                messageTitle: this.$store.getters.t("success"),
                message: this.$store.getters.t('cv_delete')
              });
              setTimeout(() => {
                this.$store.commit("newMessage");
              }, 2200);
            }
          });
        }
      }
    }
  };
</script>
<style scoped>
  .edite_btn {
    background: url("/vue/images/bg_edite_btn.png") no-repeat center center;
    background-size: 100% 100%;
    width: 62px;
    height: 62px;
    display: inline-block;
  }

  .wathermaker {
    z-index: 1 !important;
  }
</style>
<style lang="scss" scoped>
  @import url("/vue/templates/cv_pro_2.css");
  .logo{
    position: absolute;
    bottom: 30px;
    right: 15px;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/templates/pro/p-2/Show.vue